import { render } from "./Loading.vue?vue&type=template&id=4df45c9b&scoped=true"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=4df45c9b&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df45c9b"]])

export default __exports__